import RatingStar from './RatingStar'

export default RatingStar
